import { Controller } from "stimulus"
import IMask from 'imask';

export default class extends Controller {
  static values = {
    pattern: String,
  }

  connect() {
    IMask(this.element, {
      mask: this.pattern
    })
  }

  get pattern() {
    if (this.hasPatternValue) {
      return this.patternValue
    } else {
      return '+{1} (000) 000-0000'
    }
  }
}
